package com.milta.feature.optimizationquota.domain.usecase

import com.milta.feature.optimizationquota.domain.entity.OptimizationLimits
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class GetOptimizationLimitsUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(): Result<OptimizationLimits> = repository.getLimits()
}
